export interface ClientIntegration {
    clientIntegrationKey: number;
    clientIntegrationType?: string;
    integrationTypeKey: number;
    integrationActive: boolean;
    zeroPaddedIdentifier?: boolean;
    zeroPaddedLen?: number;
    new_Records_Only?: boolean;
    compensafeExport?: boolean;
    isNew?: boolean;
    integrationOption?: IntegrationOptionType;
}

export interface IClientIntegrationParameters {
    clientKey: string;
    integrationTypeKey: string;
    clientIntegrationKey: string;
    integrationActive: string;
    zeroPaddedIdentifier?: string;
    zeroPaddedLen?: string;
    new_Records_Only?: 'true' | 'false';
    compensafeExport?: string;
    action: string;
    integrationOption?: IntegrationOptionType;
}

export enum IntegrationOptionType {
    'Compensafe' = 'Compensafe',
    'LosTalker' = 'Los Talker',
    'None' = 'None',
}
